module.exports = __webpack_public_path__ + "1793882494189/images/ondato-logo.189e1d5.svg";